import { gql } from '@apollo/client';

export const FETCH_TARGET_RECOVERY_RATES = gql`
  query ($where: TargetRecoveryRateWhereInput) {
    targetRecoveryRates(where: $where) {
      clientId
      duration
      id
      targetRecoveryRate
      branchId
    }
  }
`;

export const CREATE_ONE_TARGET_RECOVERY_RATES = gql`
  mutation ($create: TargetRecoveryRateCreateInput!) {
    createOneTargetRecoveryRate(data: $create) {
      id
    }
  }
`;

export const UPDATE_ONE_TARGET_RECOVERY_RATES = gql`
  mutation ($update: TargetRecoveryRateUpdateInput!, $where: TargetRecoveryRateWhereUniqueInput!) {
    updateOneTargetRecoveryRate(data: $update, where: $where) {
      id
    }
  }
`;

export const FIND_MANY_TARGET_RECOVERY_RATES = gql`
  query ($where: TargetRecoveryRateWhereInput) {
    targetRecoveryRates(where: $where) {
      id
    }
  }
`;
